import React, { useEffect, useState } from 'react';
import { Button, Modal, Typography } from 'antd';

/**
 * The minute before the idle sign-out (auth/idle.js): a countdown, and a
 * button to stay. Any activity anywhere also cancels it - the monitor sees it
 * before this does.
 */
const IdleWarning = ({ open, secondsLeft, onStay, onSignOut }) => {
    const [left, setLeft] = useState(secondsLeft());

    useEffect(() => {
        if (!open) return undefined;
        setLeft(secondsLeft());
        const tick = setInterval(() => setLeft(secondsLeft()), 1000);
        return () => clearInterval(tick);
    }, [open, secondsLeft]);

    return (
        <Modal
            open={open}
            title="Are you still there?"
            closable={false}
            maskClosable={false}
            rootClassName="lfoc-styles-wrapper"
            footer={[
                <Button key="out" onClick={onSignOut}>Sign out</Button>,
                <Button key="stay" type="primary" onClick={onStay}>Stay signed in</Button>
            ]}
        >
            <Typography.Paragraph>
                You will be signed out in <b>{left}</b> second{left === 1 ? '' : 's'} because there has been no
                activity for almost 10 minutes.
            </Typography.Paragraph>
        </Modal>
    );
};

export default IdleWarning;
